var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _rect5, _rect6, _rect7, _path5, _rect8, _rect9, _rect10, _circle, _rect11, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworkError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 128,
    viewBox: "0 0 155 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 70,
    width: 25,
    height: 25,
    rx: 4,
    fill: "#C4BEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 9,
    width: 35,
    height: 35,
    rx: 4,
    fill: "#C4BEFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 9,
    width: 21,
    height: 21,
    rx: 4,
    fill: "#C4BEFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 102,
    width: 21,
    height: 21,
    rx: 4,
    fill: "#C4BEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.2686 84.6145H82.8544C91.2414 84.6145 98.8991 80.0426 102.744 72.7471L105.695 67.1376C106.756 65.1273 105.264 62.6954 102.943 62.6954H75.1967C73.1082 62.6954 71.6164 64.6733 72.2132 66.6512L77.2851 82.4744C77.6829 83.739 78.9095 84.6145 80.2686 84.6145Z",
    fill: "#C4BEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.051 39.5756L135.797 32.5719C136.925 30.4967 135.367 28 132.98 28H64.1931C62.0383 28 60.5134 30.0428 61.1433 32.0531L66.5799 49.0112C67.0108 50.3081 68.2374 51.1836 69.6297 51.1836H112.393C120.648 51.216 128.239 46.7414 132.051 39.5756Z",
    fill: "#C4BEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0971 79.6145H80.6829C89.0699 79.6145 96.7275 75.0426 100.573 67.7471L103.523 62.1376C104.584 60.1273 103.092 57.6954 100.772 57.6954H73.0252C70.9367 57.6954 69.4449 59.6733 70.0416 61.6512L75.1136 77.4744C75.5114 78.739 76.738 79.6145 78.0971 79.6145Z",
    fill: "#5A4BF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.88 34.5756L133.626 27.5719C134.753 25.4967 133.195 23 130.808 23H62.0216C59.8668 23 58.3419 25.0428 58.9717 27.0531L64.4084 44.0112C64.8393 45.3081 66.0659 46.1836 67.4582 46.1836H110.222C118.476 46.216 126.068 41.7414 129.88 34.5756Z",
    fill: "#5A4BF8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 82,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#5A4BF8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 5,
    width: 11,
    height: 11,
    rx: 2,
    fill: "#5A4BF8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 118,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#5A4BF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H18C20.2091 0 22 1.79086 22 4V18C22 18.3828 22.1031 18.7674 22.3589 19.0522L25.9767 23.0813C26.173 23.0493 26.3756 23.0326 26.5834 23.0326H42.7938C44.3519 23.0326 45.7442 24.0378 46.2083 25.4644L66.3304 87.2333C67.0266 89.503 65.3359 91.7727 62.916 91.7727H46.7055C45.1475 91.7727 43.7552 90.8 43.2911 89.3409L23.1689 27.572C23.1275 27.4432 23.0643 27.3217 22.9739 27.221L18.4628 22.1971C18.3458 22.0667 18.1752 22 18 22H4C1.79086 22 0 20.2091 0 18V4Z",
    fill: "#5A4BF8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 129.804,
    y: 25.3495,
    width: 21,
    height: 2.30369,
    transform: "rotate(-38.0931 129.804 25.3495)",
    fill: "#5A4BF8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 120.867,
    width: 48.9572,
    height: 2.30369,
    transform: "rotate(-47.1064 15 120.867)",
    fill: "#5A4BF8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 130.288,
    y: 94.9154,
    width: 49,
    height: 3,
    transform: "rotate(-147.417 130.288 94.9154)",
    fill: "#5A4BF8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 93,
    r: 16,
    fill: "#5A4BF8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 124.095,
    y: 84.619,
    width: 4.19048,
    height: 10.2857,
    rx: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.191,
    cy: 99.6666,
    r: 2.47619,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkError);
export default __webpack_public_path__ + "static/media/NetworkError.1b7c84eee644505fb676782f42f7c13a.svg";
export { ForwardRef as ReactComponent };